import React, {useCallback, useEffect, useState} from 'react';
import {get} from '../../../api';
import {useSelector} from 'react-redux'
import dayjs from 'dayjs';

function CompensationPlansRender(){
  const compensation_plans_enabled = useSelector(useCallback((state)=>state.settings.compensation_plans_enabled,[]))
  if(compensation_plans_enabled){
    return <FetchAndRender />
  }else{
    return null
  }
}

function FetchAndRender(props) {
  const [plans, setPlans] = useState([])
  useEffect(()=>{
    //get list of plans
    get('/compensationplans/v2').then(({plans})=>{
      setPlans(plans.filter((i)=>{
        if(i.startingKey){
          const {month, year} = i.startingKey;
          if(dayjs().set('month',month).set('year', year).isAfter(new Date())){
            return false;
          }
        }
        return true;
      }))
    })
  },[])
  return (
      <>
        {
          plans && plans.map((i)=><RenderCompPlan planId={i.id} startingKey={i.startingKey} key={String(i.id)} />)
        }
      </>
  );
}
const Cmp = React.lazy(()=>import('./CompensationPlanDisplay'))

function RenderCompPlan({planId, startingKey}){
  return <React.Suspense><Cmp planId={planId} startingKey={startingKey} /></React.Suspense>
}

export default CompensationPlansRender;
